import React from 'react';
import { ButtonGroup, Button } from '@mui/material';
import { CorporateLocation, LOCATION_OPTIONS, getSelectedLocation, setSelectedLocation } from '../utils/locationStore';

interface LocationToggleProps {
  defaultLocation?: CorporateLocation;
}

const LocationToggle: React.FC<LocationToggleProps> = ({ defaultLocation = 'pittsburgh' }) => {
  const selectedLocation = getSelectedLocation(defaultLocation);

  const handleLocationChange = (location: CorporateLocation) => {
    setSelectedLocation(location);
    // Location is global; clear the chiller lists' location-scoped filter caches so they don't
    // re-apply filters built against the other location's data after the reload.
    sessionStorage.removeItem('chillerFilterValues');
    sessionStorage.removeItem('chillerApprovalsFilterValues');
    window.location.reload();
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ fontSize: '13px', fontWeight: 600, color: '#202223', whiteSpace: 'nowrap' }}>Location:</span>
      <ButtonGroup size="small" variant="outlined">
        {LOCATION_OPTIONS.map(({ value, label }) => (
          <Button
            key={value}
            variant={selectedLocation === value ? 'contained' : 'outlined'}
            onClick={() => handleLocationChange(value)}
            style={{ textTransform: 'none', minWidth: '90px' }}
          >
            {label}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default LocationToggle;
